import React, { useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useAppSelector } from "../../redux/typedHooks";
import { UserInterface } from "../../types/user";
import { getUserBanStatusAPI } from "../../api/userApi";

const BannedUserRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const user = useAppSelector<UserInterface | null>(state => state.user.currentUser);
    const location = useLocation();

    const [isBanned, setIsBanned] = useState<boolean | null>(null);

    useEffect(() => {
        (async () => {
            if (user && user._id) {
                const response = await getUserBanStatusAPI(user._id);
                if (response.success) {
                    const { isBanned, banExpiresAt } = response.data;

                    if (isBanned) {
                        if (banExpiresAt) {
                            const expiresAt = new Date(banExpiresAt).getTime();
                            const now = Date.now();
                            if (expiresAt <= now) {
                                setIsBanned(false);
                            } else {
                                setIsBanned(true);
                            }
                        } else {
                            setIsBanned(true);
                        }
                    } else {
                        setIsBanned(false);
                    }
                }
            }
        })();
    }, [user]);

    if (isBanned === true && location.pathname !== "/user-banned") {
        return <Redirect to="/user-banned" />
    }
    if (isBanned === false && location.pathname === "/user-banned") {
        return <Redirect to="/" />
    }
    return <>{children}</>;
};

export default BannedUserRedirect;